import { themeGeneral } from "./general";
import { themeWedding } from "./wedding";

export default { themeGeneral, themeWedding };
